import { toast } from 'react-toastify';

/* global show_8843260 */

export const showAd = async () => {
    console.log("[AD] Monetag showAd() called");

    // Check if the global function exists
    if (typeof window.show_8843260 === 'function') {
        console.log("[AD] Showing Monetag ad...");

        // Show loading toast
        const loadingToast = toast.info("Loading ad...", {
            autoClose: false,
            position: "bottom-center"
        });

        try {
            // The Monetag function returns a Promise
            await window.show_8843260();

            console.log("[AD] Ad completed successfully");
            toast.dismiss(loadingToast);
            toast.success("Thanks for watching! 🎁", { position: "bottom-center", autoClose: 5000 });
            return true; // Indicate success
        } catch (error) {
            console.error("[AD] Error showing ad:", error);
            toast.dismiss(loadingToast);
            // Monetag might not provide a descriptive error object, so we handle generic errors
            toast.error("Ad failed to load or was closed.", { position: "bottom-center", autoClose: 5000 });
            return false; // Indicate failure
        }
    } else {
        console.warn("[AD] Monetag SDK not loaded (window.show_8843260 is missing)");
        toast.warning("Ads not available in this environment", {
            position: "bottom-center",
            autoClose: 5000
        });
        return true; // Skip ad if SDK is missing (e.g. dev mode)
    }
};
